export default {
  navigation: {
    home: 'Home',
    dashboard: 'Dashboard',
    login: 'Login',
    register: 'Register',
    signOut: 'Sign Out',
    about: 'About',
    community: 'Community',
    explore: 'Explore',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    freelancer: 'Freelancer',
    client: 'Client',
    help: 'Help',
    findProject: 'Find Project',
    findFreelancer: 'Find Freelancer',
    postProject: 'Post Project',
    articles: 'Articles',
    faq: 'FAQ',
    contact: 'Contact',
    searchPlaceholder: 'Search',
    show_details: 'Show details',
  },
  noResults: 'No results found',
  remove: 'Remove',
  loadMore: 'Load more',
  notFound: {
    title: 'Oops! This page has flown away',
    subtitle: "Our pigeons haven't delivered this page yet. They might be on a coffee break",
    backButton: 'Go back',
    homeButton: 'Return to the nest',
    footer1: 'The pigeons are building this page...',
    footer2: "They'll be back soon with your content!",
  },
  accountInactive: {
    contactSupport: 'If you believe this is a mistake, please contact us at',
    inactive: {
      title: 'Your account is inactive',
      subtitle:
        'Your account is currently inactive and cannot access Pigeons. Reach out to our team to reactivate it.',
    },
    suspended: {
      title: 'Your account is suspended',
      subtitle:
        'Your account has been suspended. Please contact our support team to learn more or to appeal this decision.',
    },
    banned: {
      title: 'Your account has been banned',
      subtitle:
        'Your account has been banned and can no longer access Pigeons. Contact our team if you believe this is an error.',
    },
  },
  dashboard: {
    title: 'Dashboard',
    prospects: 'Prospects',
    alliances: 'Alliances',
    jobs: 'Job Offers',
    quotes: 'Submisions',
    projectManager: 'Project Manager',
  },
  footer: {
    freelancer: 'Freelancer',
    recruiter: 'Recruiter',
    community: 'Community',
    help: 'Help',
    findProject: 'Find a project',
    signup: 'Sign up',
    articles: 'Articles',
    findFreelancer: 'Find a freelancer',
    publishProject: 'Publish a project',
    blog: 'Blog',
    aboutPigeons: 'About Pigeons',
    terms: 'Terms of use',
    privacy: 'Privacy',
    faq: 'FAQ',
    contactUs: 'Contact us',
    newsletterTitle: 'Subscribe to our newsletter',
    emailPlaceholder: 'Your email',
    emailAria: 'Your email',
    accessibility: 'Accessibility',
    copyright: '© {year} Pigeons',
    termsOfUse: 'Terms of Use',
    privacyPolicy: 'Privacy Policy',
  },
  newsletter: {
    title: 'Newsletter',
    placeholder: 'Enter your email',
  },
  language: {
    current: 'English',
    fr: 'French',
    en: 'English',
  },
  error: {
    generic: 'An error occurred',
    required: 'This field is required',
    invalidEmail: 'Invalid email address',
    fieldRequired: 'This field is required',
    uploadImage: 'Error uploading image. Please try again.',
    imageTooLarge: 'Image size must be less than 5MB',
    boundary: {
      title: 'Something went wrong',
      subtitle: "We're sorry, but there was an error loading this page.",
      reloadButton: 'Reload Page',
      footer1: 'The pigeons are trying to fix this...',
      footer2: 'They will be back soon with your content!',
    },
  },
  role: {
    freelancer: 'Freelancer',
    recruiter: 'Recruiter',
    administrator: 'Administrator',
  },
  companyType: {
    individual: 'Individual',
    company: 'Corporate',
    organization: 'Organization',
  },
  obnl_review_status: {
    not_applicable: 'Not applicable',
    pending: 'Pending review',
    approved: 'Approved',
    rejected: 'Rejected',
  },
  status: {
    pending: 'Pending',
    accepted: 'Accepted',
    rejected: 'Rejected',
  },
  loading: 'Loading...',
  findItem: 'Find A',
  serviceCategories: {
    'administration-de-serveur': 'Server Administration',
    'administration-reseau': 'Network Administration',
    'analyse-statistique': 'Statistical Analysis',
    'animation-2d': '2D Animation',
    'animation-3d': '3D Animation',
    'applications-mobiles': 'Mobile Applications',
    artistes: 'Artists',
    architecture: 'Architecture',
    'assistant-personnel': 'Personal Assistant',
    'blog-et-redaction-d-articles': 'Blog and Article Writing',
    camera: 'Camera',
    'coiffure-maquillage': 'Hairdressing/Makeup',
    comptabilite: 'Accounting',
    'conception-graphique': 'Graphic Design',
    'consultant-en-gestion-d-entreprise': 'Business Management Consultant',
    'contenu-de-site-web': 'Website Content',
    costumes: 'Costumes',
    'creation-de-logo': 'Logo Creation',
    'dba-administration-de-base-de-donnee': 'DBA - Database Administration',
    'design-d-interface-de-logiciel': 'Software Interface Design',
    'design-d-interface-ux-ui': 'UX-UI Interface Design',
    'design-d-interieur': 'Interior Design',
    'design-imprime': 'Print Design',
    'design-web': 'Web Design',
    'direction-artistique': 'Art Direction',
    'direction-de-creation': 'Creative Direction',
    'developpement-de-jeux': 'Game Development',
    'developpement-de-logiciel-de-bureau': 'Desktop Software Development',
    'e-commerce': 'E-commerce',
    'ergonomie-de-logiciel': 'Software Ergonomics',
    'ergonomie-web-qa': 'Web Ergonomics QA',
    'erp-crm-mise-en-oeuvre': 'ERP / CRM Implementation',
    'gestion-de-courriels': 'Email Management',
    'gestion-de-projet': 'Project Management',
    'gestion-de-projet-logiciel': 'Software Project Management',
    'gestion-de-projet-web': 'Web Project Management',
    'gestion-des-medias-sociaux': 'Social Media Management',
    illustration: 'Illustration',
    'inbound-marketing-marketing-d-attraction': 'Inbound Marketing',
    'ingenierie-et-design-technique': 'Engineering and Technical Design',
    'intelligence-artificielle': 'Artificial Intelligence',
    juridique: 'Legal',
    'logiciel-plug-ins': 'Software Plug-ins',
    'marketing-par-courriel': 'Email Marketing',
    'marketing-web': 'Web Marketing',
    'modelisation-3d-et-cad': '3D Modeling and CAD',
    photographie: 'Photography',
    'plan-d-affaires': 'Business Plan',
    'post-production': 'Post-production',
    'pr-relations-publiques': 'PR - Public Relations',
    'production-audio': 'Audio Production',
    'production-imprime': 'Print Production',
    'production-tv': 'TV Production',
    'production-video': 'Video Production',
    'programmation-web': 'Web Programming',
    'presentation-graphique': 'Graphic Presentation',
    publicite: 'Advertising',
    'recherche-web': 'Web Research',
    recrutement: 'Recruitment',
    'ressources-humaines': 'Human Resources',
    realisation: 'Directing',
    redaction: 'Writing',
    'redaction-creative': 'Creative Writing',
    'redaction-technique': 'Technical Writing',
    'regie-tv': 'TV Production Management',
    'regie-production': 'Production Management',
    'revision-de-textes': 'Text Proofreading',
    'saisie-de-donnees': 'Data Entry',
    'scripts-et-utilitaires': 'Scripts and Utilities',
    'scenographie-decors': 'Scenography/Set Design',
    'sem-marketing-par-le-positionnement-payant-dans-les-moteurs-de-recherche':
      'SEM - Paid Search Engine Marketing',
    'seo-optimisation-organique-pour-les-moteurs-de-recherche':
      'SEO - Organic Search Engine Optimization',
    'service-client': 'Customer Service',
    'service-conseil': 'Consulting Service',
    'services-financiers-et-de-planification': 'Financial and Planning Services',
    'smm-marketing-par-les-medias-sociaux': 'SMM - Social Media Marketing',
    son: 'Sound',
    'soutien-technique': 'Technical Support',
    'soutien-telephonique': 'Phone Support',
    'strategie-et-planification': 'Strategy and Planning',
    technique: 'Technical',
    traduction: 'Translation',
    'traitement-de-commandes-en-ligne': 'Online Order Processing',
    'traitement-des-paiements': 'Payment Processing',
    'transcription-de-textes': 'Text Transcription',
    transport: 'Transport',
    'telemarketing-et-televente': 'Telemarketing and Telesales',
    'ventes-et-prospection': 'Sales and Prospecting',
    voip: 'VOIP',
    'voix-hors-champ': 'Voice-over',
    'etudes-de-marche': 'Market Research',
    'autres-communication-et-marketing': 'Communication and Marketing',
    'autres-design-et-multimedia': 'Design and Multimedia',
    'autres-developpement-de-logiciels': 'Software Development',
    'autres-developpement-web': 'Web Development',
    'autres-radio-tv-cinema-et-arts-de-la-scene': 'Radio-TV-Cinema and Performing Arts',
    'autres-redaction-et-traduction': 'Writing and Translation',
    'autres-reseaux-et-systemes-d-information': 'Networks and Information Systems',
    'autres-service-a-la-clientele': 'Customer Service',
    'autres-services-aux-entreprises': 'Business Services',
    'autres-soutien-administratif': 'Administrative Support',
  },
  home: {
    hero: {
      title: 'Find the best freelancers and teams for your project',
      subtitle: 'Connect, collaborate, and succeed with our smart matching platform.',
      getStarted: 'Get Started',
      browse: 'Browse Projects',
    },
    features: {
      title: 'Features',
      subtitle: 'Why choose our platform?',
      smartMatching: {
        title: 'Smart Matching',
        description:
          'Our advanced algorithm connects you with the most suitable freelancers and teams for your needs.',
      },
      teamFormation: {
        title: 'Team Formation',
        description: 'Easily form and manage teams to tackle projects of any size.',
      },
      securePayments: {
        title: 'Secure Payments',
        description: 'Enjoy peace of mind with our secure and reliable payment system.',
      },
    },
  },
  industries: {
    'accommodation-and-food-services': 'Accommodation and Food Services',
    'advertising-and-public-relations': 'Advertising, Public Relations and Related Services',
    'aerospace-products-and-parts': 'Aerospace Products and Parts',
    'agriculture-and-fishing': 'Agriculture and Fishing',
    'architectural-and-engineering-services': 'Architectural, Engineering and Related Services',
    'arts-and-entertainment': 'Arts, Entertainment and Recreation',
    'business-support-services': 'Business, Building and Other Support Services',
    'computer-and-electronic-products': 'Computer, Electronic, Electrical Products',
    'computer-systems-design': 'Computer Systems Design and Related Services',
    construction: 'Construction',
    'educational-services': 'Educational Services',
    'fabricated-metal-products': 'Fabricated Metal Product Manufacturing',
    finance: 'Finance',
    'food-and-beverage-manufacturing': 'Food, Beverage and Tobacco Product Manufacturing',
    'forestry-and-logging': 'Forestry and Logging',
    'furniture-manufacturing': 'Furniture and Related Product Manufacturing',
    'health-care': 'Health Care',
    'information-and-cultural-industries': 'Information and Cultural Industries',
    insurance: 'Insurance Carriers and Related Activities',
    'legal-and-accounting-services': 'Legal and Accounting Services',
    'machinery-manufacturing': 'Machinery Manufacturing',
    'mining-and-oil-and-gas-extraction': 'Mining and Oil and Gas Extraction',
    'miscellaneous-manufacturing': 'Miscellaneous Manufacturing',
    'non-metallic-mineral-product-manufacturing': 'Non-Metallic Mineral Product Manufacturing',
    'paper-manufacturing': 'Paper Manufacturing',
    'petroleum-and-coal-products': 'Petroleum and Coal Products Manufacturing',
    'plastic-and-rubber-products': 'Plastic and Rubber Products Manufacturing',
    'primary-metal-manufacturing': 'Primary Metal Manufacturing',
    'printing-and-related-support': 'Printing and Related Support Activities',
    'professional-scientific-and-technical-services':
      'Professional, Scientific and Technical Services',
    'public-administration': 'Public Administration',
    'real-estate': 'Real Estate and Rental and Leasing',
    'retail-trade': 'Retail Trade',
    'scientific-research-and-development': 'Scientific Research and Development Services',
    'social-assistance': 'Social Assistance',
    'transportation-and-warehousing': 'Transportation and Warehousing',
    utilities: 'Utilities',
    'waste-management': 'Waste Management and Remediation Services',
    'wholesale-trade': 'Wholesale Trade',
    'wood-product-manufacturing': 'Wood Product Manufacturing',
  },
  navBar: {
    home: 'Home',
    prospects: 'Prospects',
    alliances: 'Alliances',
    jobs: 'Job Offers',
    quotes: 'Submisions',
    projects: 'Project Manager',
    credits: 'My tokens',
    contacts: 'Contacts',
    settings: 'Settings',
    dockLeft: 'Dock navigation to the left',
    dockTop: 'Dock navigation to the top',
  },
  breadcrumbs: {
    dashboard: 'Dashboard',
    settings: 'My profile',
    find: 'Find',
    freelancer: 'A freelancer',
    notifications: 'Notifications',
    prospects: 'Prospects',
    jobs: 'Job Offers',
    alliances: 'My Alliances',
    quotes: 'My Submisions',
    projects: 'Project Manager',
    users: 'Users',
    reports: 'Reports',
    services: 'Services',
    industries: 'Industries',
    cities: 'Cities',
    reviews: 'Reviews',
    contacts: 'Contacts',
  },
  accountCard: {
    title: 'Account',
    settings: 'Settings',
    wallet: 'Wallet',
    payment: 'Payment',
    signOut: 'Sign Out',
  },
  settings: {
    title: 'My profile',
  },
  mobileNavigation: {
    mainMenu: 'Main menu',
    myCredits: 'My tokens',
  },
  form_fields: {
    firstName: 'First Name',
    firstNamePlaceholder: 'Enter your first name',
    lastName: 'Last Name',
    lastNamePlaceholder: 'Enter your last name',
    city: 'City',
    cityPlaceholder: 'Enter your city',
    postalCode: 'Postal Code',
    postalCodePlaceholder: 'Enter your postal code',
    phone: 'Phone',
    phonePlaceholder: 'Enter your phone number',
    languagesSpoken: 'Languages spoken',
    remoteWork: 'Do you work remotely',
    yes: 'Yes',
    no: 'No',
    professionalDescription: 'Describe your professional practice',
    professionalDescriptionPlaceholder:
      'Describe your professional experience, skills and what makes you unique',
    servicesHint: 'Search or add a service',
    selectService: 'Select a service',
    servicePlaceholder: 'Service ...',
    businessIndustries: 'Business Industries',
    businessIndustriesHint: 'Add at least 1 business industry',
    businessIndustryNotFoundHint: "You didn't find your business industry? Write it down",
    newBusinessIndustryPlaceholder: 'New business industry',
    newDescriptionPlaceholder: 'Description (optional)',
    companyName: 'Company Name',
    companyNamePlaceholder: 'Enter your company name',
    jobTitle: 'Your job title',
    jobTitlePlaceholder: 'Enter your job title',
    organizationWebsite: 'Organization website',
    organizationWebsitePlaceholder: 'Enter your organization website',
    organizationNumber: 'Organization number',
    organizationNumberPlaceholder: 'Enter your organization number',
    charactersRemaining: 'characters remaining',
    servicesOffered: 'Services offered',
  },
  form_actions: {
    cancel: 'Cancel',
    cancelling: 'Cancelling...',
    confirm: 'Confirm',
    confirming: 'Confirming...',
    save: 'Save',
    saving: 'Saving...',
    accept: 'Accept',
    accepting: 'Accepting...',
    decline: 'Decline',
    declining: 'Declining...',
    close: 'Close',
    send: 'Send',
    sending: 'Sending...',
    next: 'Next',
    back: 'Back',
    previous: 'Previous',
    skip: 'Skip',
    cancel_close: 'Cancel and close',
    manage: 'Manage',
    add: 'Add',
    remove_industry: 'Remove industry',
    remove_serviceCategory: 'Remove service',
    edit: 'Edit',
    delete: 'Delete',
    editing: 'Editing...',
    return: 'Return',
  },
  cancelAndClose: 'Cancel and close',
  ratingLabels: {
    '0': 'Not yet rated',
    '1': 'Very bad',
    '2': 'Bad',
    '3': 'Average',
    '4': 'Good',
    '5': 'Excellent',
  },
  achievements: {
    title: 'Realizations',
    description: 'About',
  },
  search: {
    find: 'Find',
    findJob: 'Find a Job',
    findFreelancer: 'Find A Freelancer',
    freelancer: 'Freelancer',
    project: 'Project',
    search: 'Search',
    searchPlaceholder: 'What are you looking for?',
  },
  conjonctions: {
    for: 'for',
  },
  alliance_statuses: {
    pending: 'Alliance pending',
    accepted: 'Alliance accepted',
    rejected: 'Alliance rejected',
    blocked: 'Alliance blocked',
    retired: 'Alliance retired',
  },
  budget_ranges: {
    less_than_500: 'Less than 500$',
    '500_to_1000': '500$ to 1 000$',
    '1000_to_2000': '1 000$ to 2 000$',
    '2000_to_5000': '2 000$ to 5 000$',
    '5000_to_10000': '5 000$ to 10 000$',
    more_than_10000: 'More than 10 000$',
  },
  job_listing_types: {
    featured: 'Featured',
    urgent: 'Urgent',
  },
  buttons: {
    viewProfile: 'View profile',
  },
  quote_statuses: {
    draft: 'Draft',
    submitted: 'Submitted',
    accepted: 'Accepted',
    rejected: 'Rejected',
    retired: 'Retired',
    change_requested: 'Change requested',
    job_cancelled: 'Job cancelled',
    alliance_retired: 'Alliance retired',
    not_accepted: 'Not selected',
  },
  job_statuses: {
    cancelled: 'Cancelled',
    paused: 'Paused',
    in_progress: 'In progress',
    completed: 'Completed',
    open: 'Open',
    closed: 'Closed',
    expired: 'Expired',
    reviewing_quotes: 'Reviewing quotes',
  },
  wallet: {
    title: 'My wallet',
    credits: 'My tokens',
    manage: 'Manage',
  },
  user_status: {
    active: 'Active',
    inactive: 'Inactive',
    banned: 'banned',
  },
  content_type: {
    job: 'Offer',
    profile: 'User',
    review: 'Review',
    quote: 'Submision',
    quote_request: 'Quote request',
    issue: 'Issue',
  },
  report_status: {
    pending: 'pending',
    resolved: 'resolved',
    dismissed: 'dismissed',
  },
  update_user_status: "Update <bold>{{user}}</bold>'s status",
  update_job_status: "Update <bold>{{job}}</bold>'s status",
  select_status: 'Select a status',
  update_status_button: 'Update the status',
  all_types: 'All types',
  all_statuses: 'All statuses',
  all_obnl_review_statuses: 'All OBNL review statuses',
  nothing_to_show: 'Nothing to show',
  all_roles: 'All roles',
  languageTitle: 'Language',
  service: 'Service',
  general: 'General',
  add_new_service: 'Add new service',
  add_new_industry: 'Add new industry',
  add_new_city: 'Add new city',
  serviceGroups: {
    administration_et_gestion: 'Administration and Management',
    design_et_multimedia: 'Design and Multimedia',
    developpement_web_et_logiciel: 'Web and Software Development',
    marketing_communication_et_ventes: 'Marketing, Communication and Sales',
    production_audiovisuelle: 'Audiovisual Production',
    redaction_et_traduction: 'Writing and Translation',
    services_juridiques: 'Legal Services',
    services_techniques_et_support: 'Technical Services and Support',
    autres_services: 'Other Services',
    autres: 'Other',
  },
  badges: {
    language: 'Language',
    service: 'Service',
    city: 'City',
    publishedAt: 'Publication date',
    alphabetical: 'Alphabetical order',
    allianceCount: 'Alliance count sort',
    proximity: 'Proximity',
    rating: 'Rating',
  },
  errors: {
    generic: 'An error occurred',
  },
  alliances: {
    noneActive: 'No active alliances',
  },
  MyWallet: 'My Wallet',
  backToDashboard: 'Back to dashboard',
  about: 'About',
  availability: 'Availability',
  businessIndustries: 'Industries',
  cancel_changes: 'Cancel changes',
  collapse: 'Collapse',
  expand: 'Expand',
  first_name_fallback: 'User',
  generic_error: 'An error occurred. Please try again.',
  information: 'Information',
  location: 'Location',
  noUsers: 'No recent users',
  notification: 'Notification',
  requestQuote: 'Request a quote',
  viewJobs: 'View job offers',
  confirmEmail: {
    resendIn: 'Resend possible in {{minutes}} min...',
    title: 'Check your emails',
  },
  new_industry_suggested_modal: {
    title: 'Suggest a new industry',
  },
} as const;
